import React, {useEffect, useState} from 'react';
import { useForm } from 'react-hook-form';
import logo from 'images/branding/logo.png';
import {ButtonLoader} from 'features/buttonLoader';
import {selectIsLoading, selectIsAuthenticated} from '../selectors';
import { selectIsAllowedToJoinRoom } from '../../conference/selectors';
import './index.scss';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../slice';
import { useHistory } from 'react-router-dom';
import { joinAsModerator } from '../../conference/actions';
import { Link } from 'react-router-dom';
import { UrlParser } from 'url-params-parser';

type SignupData = {
  email: string;
  password: string;
  room:string
};

export function Signup() {
  const [boxPlacement, setBoxPlacement] = useState('');
  const { register, handleSubmit, errors } = useForm<SignupData>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [room, setRoom] = useState('');

  const isLoading = useSelector(selectIsLoading);
  const isAllowedToJoinRoom = useSelector(selectIsAllowedToJoinRoom);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const onSubmit = (data: SignupData) => {
    dispatch(login({...data,room}));
  }

  useEffect(() => {
    /* this useEffect is used for CSS purpose */
    function handleResize() {
      const boxHeight = document.querySelector("#signupInnerBox");
      if(boxHeight && window.innerHeight > boxHeight.clientHeight){
        setBoxPlacement('center');
      } else {
        setBoxPlacement('scroll');
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    const parsedUrl = UrlParser(window.location.href, '/:room');
    if(parsedUrl.namedParams.room !== '/'){
      setRoom(parsedUrl.namedParams.room);
    } 

    return () => window.removeEventListener("resize", handleResize);
  },[])

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(joinAsModerator());
    }
  }, [dispatch, history, isAuthenticated]);

  useEffect(() => {
    if (isAllowedToJoinRoom) {
      history.push('/conference');
    }
  }, [history, isAllowedToJoinRoom]);

  return (
    <div className={`SIGNUP-- ${boxPlacement}`}>
      <div className="innerBox" id="signupInnerBox">
        <img className="logo" src={logo} alt="" />
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="nameInputDiv">
            <label>Username/Email Address</label>
            <input name="email" ref={register({ required: true })} />
            {errors.email?.type === 'required' && (
              <div className="input-validation-error">Email is required</div>
            )}
          </div>  
          <div className="nameInputDiv">
            <label>Password</label>
            <input name="password" ref={register({ required: true })} type="password" />
            {errors.email?.type === 'required' && (
              <div className="input-validation-error">Password is required</div>
            )}
          </div>
          <button className="primary-button signupButton" type="submit">
            Sign Up
            {isLoading ? <ButtonLoader /> : ''}
          </button>
        </form>
        <div className="alreadyHaveAccount">
          <span>Already have an account?</span>
          <Link to="/login">&nbsp;&nbsp;Sign in</Link>
        </div>
      </div>
    </div>
  )
}